// extracted by mini-css-extract-plugin
module.exports = {"slider":"PartnerSlider_slider__K_mL1","larger":"PartnerSlider_larger__QAxow"};